import { ReactElement } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import {
  DropdownWrapper,
  EditableDropdown,
  Input,
  PageWrapper
} from '../../../../../components'
import strings from '../../../../../locale/en'
import { RootState } from '../../../../../redux/store'
import { updateStudentInformation } from '../../../../../redux/userDetail/actions'
import {
  casteList,
  categoryList,
  checkBoxDropdownList,
  genderList,
  nationalityList,
  religionList,
  studentTypeList
} from './const'
import { FlexWrapper, InfoWrapper } from './subcomponents'
import DatePicker from 'react-datepicker'
import { format } from 'date-fns'
import { DATE_FORMAT_YYYYMMDD } from '../../../../../const/dateFormat'

const PersonalDetails = (): ReactElement => {
  const {
    studentInformation: {
      studentName,
      fathersName,
      mothersName,
      dob,
      aadhar,
      enrollmentNumber,
      userName,
      passwordUpdated
    }
  } = useSelector(
    (state: RootState) => ({
      studentInformation: state.userDetail.studentInformation
    }),
    shallowEqual
  )
  const dispatch = useDispatch()

  const {
    studentDetails: {
      studentNameLabel,
      studentNamePlaceholder,
      enterDob,
      genderLabel,
      genderPlaceholder,
      dobLabel,
      nationalityLabel,
      nationalityPlaceholder,
      communityPlaceholder,
      communityLabel,
      religionPlaceholder,
      religionLabel,
      castePlaceholder,
      casteLabel,
      studentTypePlaceholder,
      studentTypeLabel,
      physicallyChallengedLabel,
      aadharNumberPlaceHolder,
      aadharNumberLabel,
      enterEnrollment,
      enrollmentNumberLabel,
      userNameLabel,
      userNamePlaceholder,
      passwordLabel,
      passwordPlaceHolder,
      fatherNameLabel,
      fatherNamePlaceholder,
      motherNameLabel,
      motherNamePlaceholder
    }
  } = strings

  return (
    <PageWrapper>
      <InfoWrapper>
        <FlexWrapper width="100%">
          <DropdownWrapper>
            <Input
              label={studentNameLabel}
              isRequired
              placeholder={studentNamePlaceholder}
              value={studentName || ''}
              width="100%"
              onChange={(value: string) => {
                dispatch(updateStudentInformation({ studentName: value }))
              }}
              height="50px"
            />
          </DropdownWrapper>
          <DropdownWrapper>
            <Input
              label={fatherNameLabel}
              isRequired
              placeholder={fatherNamePlaceholder}
              value={fathersName || ''}
              width="100%"
              onChange={(value: string) => {
                dispatch(updateStudentInformation({ fathersName: value }))
              }}
              height="50px"
            />
          </DropdownWrapper>
          <DropdownWrapper>
            <Input
              label={motherNameLabel}
              isRequired
              placeholder={motherNamePlaceholder}
              value={mothersName || ''}
              width="100%"
              onChange={(value: string) => {
                dispatch(updateStudentInformation({ mothersName: value }))
              }}
              height="50px"
            />
          </DropdownWrapper>
          <DropdownWrapper>
            <EditableDropdown
              dropdownList={genderList}
              title={genderLabel}
              isRequired
              placeholder={genderPlaceholder}
              handleSelect={(item) =>
                dispatch(updateStudentInformation({ gender: item.name }))
              }
            />
          </DropdownWrapper>
          <DropdownWrapper>
            <DatePicker
              showMonthDropdown
              showYearDropdown
              dropdownMode="select"
              selected={dob ? new Date(dob) : new Date()}
              onSelect={(date: Date) =>
                dispatch(updateStudentInformation({ dob: date ? format(date, DATE_FORMAT_YYYYMMDD) : '' }))
              }
              onChange={(date: Date) => {
                dispatch(updateStudentInformation({ dob: date ? format(date, DATE_FORMAT_YYYYMMDD) : '' }))
              }
              }
              placeholderText={enterDob}
              customInput={
                <Input
                  value={dob}
                  label={dobLabel}
                  placeholder={enterDob}
                  height="50px"
                  suffix={['far', 'calendar']}
                  onChange={(value: string) => {
                    dispatch(updateStudentInformation({ dob: value }))
                  }}
                />
              }
            />
          </DropdownWrapper>
          <DropdownWrapper>
            <EditableDropdown
              dropdownList={studentTypeList}
              title={studentTypeLabel}
              placeholder={studentTypePlaceholder}
              handleSelect={(item) =>
                dispatch(updateStudentInformation({ studentType: item.name }))
              }
            />
          </DropdownWrapper>
          <DropdownWrapper>
            <EditableDropdown
              dropdownList={checkBoxDropdownList}
              title={physicallyChallengedLabel}
              placeholder={'Select'}
              handleSelect={({ name }) => {
                const value = name === 'Yes' ? true : false
                dispatch(updateStudentInformation({ challenged: value }))
              }}
            />
          </DropdownWrapper>
          <DropdownWrapper>
            <Input
              label={aadharNumberLabel}
              placeholder={aadharNumberPlaceHolder}
              value={aadhar || ''}
              isRequired
              width="100%"
              onChange={(value: string) => {
                dispatch(updateStudentInformation({ aadhar: value }))
              }}
              height="50px"
            />
          </DropdownWrapper>
          <DropdownWrapper>
            <EditableDropdown
              dropdownList={religionList}
              title={religionLabel}
              isRequired
              placeholder={religionPlaceholder}
              handleSelect={(item) =>
                dispatch(updateStudentInformation({ religion: item.name }))
              }
            />
          </DropdownWrapper>
          <DropdownWrapper>
            <EditableDropdown
              dropdownList={categoryList}
              title={communityLabel}
              placeholder={communityPlaceholder}
              handleSelect={(item) =>
                dispatch(updateStudentInformation({ community: item.name }))
              }
            />
          </DropdownWrapper>
          <DropdownWrapper>
            <EditableDropdown
              dropdownList={casteList}
              title={casteLabel}
              placeholder={castePlaceholder}
              handleSelect={(item) =>
                dispatch(updateStudentInformation({ caste: item.name }))
              }
            />
          </DropdownWrapper>
          <DropdownWrapper>
            <EditableDropdown
              dropdownList={nationalityList}
              title={nationalityLabel}
              isRequired
              placeholder={nationalityPlaceholder}
              handleSelect={(item) =>
                dispatch(updateStudentInformation({ nationality: item.name }))
              }
            />
          </DropdownWrapper>
          <DropdownWrapper>
            <Input
              label={enrollmentNumberLabel}
              placeholder={enterEnrollment}
              value={enrollmentNumber || ''}
              isRequired
              width="100%"
              onChange={(value: string) => {
                dispatch(updateStudentInformation({ enrollmentNumber: value }))
              }}
              height="50px"
            />
          </DropdownWrapper>
          <DropdownWrapper>
            <Input
              label={userNameLabel}
              placeholder={userNamePlaceholder}
              value={userName || ''}
              width="100%"
              onChange={(value: string) => {
                dispatch(updateStudentInformation({ userName: value }))
              }}
              height="50px"
            />
          </DropdownWrapper>
          <DropdownWrapper>
            <Input
              label={passwordLabel}
              placeholder={passwordPlaceHolder}
              value={passwordUpdated || ''}
              isRequired
              width="100%"
              onChange={(value: string) => {
                dispatch(updateStudentInformation({ passwordUpdated: value }))
              }}
              height="50px"
            />
          </DropdownWrapper>
        </FlexWrapper>
      </InfoWrapper>
    </PageWrapper>
  )
}

export default PersonalDetails
